// extracted by mini-css-extract-plugin
module.exports = {"bb-video":"bb-video__0ouZh"};